<template>
  <div>
    <MainPopupMobile v-if="commonStore.isMobile" />
    <MainPopupDesktop v-else />
  </div>
</template>
<script setup lang="ts">
import MainPopupDesktop from '@views/main/desktop/MainPopup.vue';
import MainPopupMobile from '@views/main/mobile/MainPopup.vue';
import { useCommonStore } from '@stores';
const commonStore = useCommonStore();
</script>

<style scoped lang="scss"></style>
